import { render, staticRenderFns } from "./teaminfo.vue?vue&type=template&id=46ed19eb"
import script from "./teaminfo.vue?vue&type=script&lang=js"
export * from "./teaminfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports